import { ReviewStageDataFieldTypeEnum } from '../../schemas';

const QUESTION_TYPE_OPTIONS = [
  {
    value: ReviewStageDataFieldTypeEnum.text_field,
    label: 'Text',
  },
  {
    value: ReviewStageDataFieldTypeEnum.radio,
    label: 'Multiple Choice (single answer)',
  },
  {
    value: ReviewStageDataFieldTypeEnum.datepicker,
    label: 'Date Picker',
  },
  {
    value: ReviewStageDataFieldTypeEnum.dropdown,
    label: 'Dropdown',
  },
  {
    value: ReviewStageDataFieldTypeEnum.checkboxes,
    label: 'Multiple Choice (multiple answers)',
  },
];
type QuestionTypeOptions = typeof QUESTION_TYPE_OPTIONS;
export type QuestionTypeOption = QuestionTypeOptions[number];

export const HIRING_MANAGER_PAY_RATE_KEY =
  'hiring_manager_confirmed_pay_rate' as const;
export const STANDARD_QUESTION_OPTIONS = [
  {
    value: HIRING_MANAGER_PAY_RATE_KEY,
    label: 'Pay Rate',
  },
];

export const STANDARD_QUESTION_VALUES = STANDARD_QUESTION_OPTIONS.map(
  ({ value }) => value,
);

export type StandardQuestions = typeof STANDARD_QUESTION_OPTIONS;
export type StandardQuestion = StandardQuestions[number];

export type GroupedQuestionOption = {
  label: string;
  options: QuestionTypeOptions | StandardQuestions;
};

export const GROUPED_QUESTION_OPTIONS = [
  {
    label: 'question types' as const,
    options: QUESTION_TYPE_OPTIONS,
  },
  {
    label: 'custom' as const,
    options: STANDARD_QUESTION_OPTIONS,
  },
];
export const ALL_GROUPED_QUESTIONS = GROUPED_QUESTION_OPTIONS.map(
  ({ options }) => options,
).flat();

export type GroupedQuestionsValues =
  (typeof GROUPED_QUESTION_OPTIONS)[number]['options'][number]['value'];

export const ALL_GROUPED_QUESTIONS_VALUES: Array<GroupedQuestionsValues> =
  GROUPED_QUESTION_OPTIONS.map(({ options }) =>
    options.map(({ value }) => value),
  ).flat();
